<template>
<transition name="toast-transition">
    <div class="toast" :class="classObj" v-if="getToastModel.show">
      <div class="toast-header">
        <strong class="mr-auto">Notification:</strong>
        <small>{{getToastModel.time}}</small>
        <button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Close" @click="hideToast">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="toast-body">
        {{getToastModel.text}}
      </div>
    </div>
</transition>    
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
export default {
    name: 'Toast',
    data: () => ({

    }),
    methods: {
        hideToast() {
            this.unToast();
        },        
        ...mapActions({
            unToast: "notificationModule/unToast" 
        })
    },
    computed: {
        ...mapGetters({
            getToastModel: "notificationModule/getToastModel",
        }),
            classObj() {
      let klass = {};
      let { getToastModel } = this;
      klass['toast--top'] = getToastModel.posY === 'top';
      klass['toast--bottom'] = getToastModel.posY === 'bottom';
      klass['toast--left'] = getToastModel.posX === 'left';
      klass['toast--right'] = getToastModel.posX === 'right';
      klass['toast--show'] = getToastModel.show === true;
      klass['toast--hide'] = getToastModel.show === false;
      return klass;
    }        
    }    
}
</script>

<style lang="scss">

    .toast {
        position: fixed;
        z-index: 1040;
        &--top {
        top: 80px!important;
    }
    &--bottom {
        bottom: 0!important;
    }
    &--left {
        left: 0!important;
    }
    &--right {
        right: 20px!important;
    }
    &--show {
        opacity: 0.95!important;
    }
    &--hide {
        opacity: 0!important;
    }
}
.toast-transition-enter-active {
    transition: all .8s ease;
}
.toast-transition-leave-active {
    transition: all 1.2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.toast-transition-enter, .toast-transition-leave-to {
  transform: translateX(250px);
  opacity: 0;
}
</style>
